import { GemmaError } from "@gemma/errors";

export const Errors = {
  UnhandledError: (errorId: string) => new GemmaError(`Sorry, there was an unhandled error in the system${errorId ? `, please report this following id: ${errorId}` : ". Please report this"} to your agency administrator.`, { ui: true, ref: { type: "UnhandledError", group: "UnhandledError", id: "UnhandledError" }, data: { fieldName: undefined, errorId } }),
};
